import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import * as AdminActions from "../../actions/admin";
import UserFieldDataType from "../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from "./UserFieldElement";
import {NotificationManager} from "react-notifications";

const margin = '50px';
const sectionWidth = '40%';
const buttonWidth = '80%';
const headerHeight = '60px';
const footerHeight = '60px';

class StationSelection extends React.Component {

    static propTypes = {
        targetId: PropTypes.string, // Section (two digits) or club (three digits) number
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedStations: [],
            selectedSelections: [],
            viewMode: '0', // 0: country wide selections, 1: group selections, 2: section selections, 3: club selections.
        };
    }

    componentDidMount() {
        this.loadStations(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.targetId !== nextProps.targetId) this.loadStations(nextProps);
    }

    loadStations = newestProps => {
        newestProps.dispatch(AdminActions.getStationSelections(newestProps.targetId));
        this.setState({
            viewMode: /^[0-9]{3}$/.test(newestProps.targetId) ? '3' : (/^[0-9]{2}$/.test(newestProps.targetId) ? '2' : (/^[0-9]$/.test(newestProps.targetId) ? '1' : '0'))
        })
    };

    render() {
        const viewModes = [{key: '0', value: 'hele landet'}];
        let groupId = null;
        let sectionId = null;
        let clubId = null;
        if (/^[0-9]{3}$/.test(this.props.targetId)) {
            clubId = this.props.targetId;
            const club = this.props.admin.clubs.get(this.props.targetId) || null;
            if (club !== null) {
                groupId = club.Sektionsnr.substr(0, 1);
                sectionId = club.Sektionsnr;
                viewModes.push({key: '1', value: 'sektionsgruppe ' + club.Sektionsnr.substr(0, 1)});
                viewModes.push({key: '2', value: 'sektion ' + club.Sektionsnr});
            }
            viewModes.push({key: '3', value: 'forening ' + this.props.targetId + (club !== null && club.Navn !== null ? ' (' + club.Navn + ')' : '')});
        } else if (/^[0-9]{2}$/.test(this.props.targetId)) {
            groupId = this.props.targetId.substr(0, 1);
            sectionId = this.props.targetId;
            viewModes.push({key: '1', value: 'sektionsgruppe ' + this.props.targetId.substr(0, 1)});
            viewModes.push({key: '2', value: 'sektion ' + this.props.targetId});
        } else if (/^[0-9]$/.test(this.props.targetId)) {
            groupId = this.props.targetId;
            viewModes.push({key: '1', value: 'sektionsgruppe ' + this.props.targetId});
        }
        const allStations = this.props.admin.stations.toArray();
        const filteredSelections = this.props.admin.stationSelections.filter(selection => allStations.findIndex(station => station.Stationsnr === selection.station) >= 0 &&
            (
                selection.target === 'A' ||
                (this.state.viewMode >= '1' && groupId !== null && selection.target === groupId) ||
                (this.state.viewMode >= '2' && sectionId !== null && selection.target === sectionId) ||
                (this.state.viewMode >= '3' && clubId !== null && selection.target === clubId)
            )
        ).toArray();
        const selectedStations = filteredSelections.filter((selection, ix) => filteredSelections.findIndex(selection2 => selection2.station === selection.station) === ix).map(station => ({
            Stationsnr: station.station,
            Navn: allStations[allStations.findIndex(station2 => station2.Stationsnr === station.station)].Navn,
            Levels: filteredSelections.filter(selection => selection.station === station.station)
                .map(selection => selection.target === 'A' ? 0 : (selection.target === groupId ? 1 : (selection.target === sectionId ? 2 : 3)))
                .sort((l1, l2) => l1 - l2).map(lvl => String(lvl))
        }));
        return <div style={{position: 'absolute', top: margin, left: margin, bottom: margin, right: margin}}>
            <div>
                <label htmlFor="viewMode">Stationsvalg for</label> <UserFieldElement dataType={UserFieldDataType.enum} placeholder={false} className="field450" containerClassName="display-inline-block"
                       name="viewMode" id="viewMode" value={this.state.viewMode} options={viewModes}
                       autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                       onChange={e => {
                           this.setState({
                               viewMode: e.target.value,
                               selectedStations: [],
                               selectedSelections: [],
                           });
                       }}
                />
            </div>
            <div style={{position: 'absolute', top: headerHeight, bottom: footerHeight, left: 0, right: 0}}>
                <div style={{position: 'absolute', top: 0, bottom: 0, left: 0, width: sectionWidth, overflow: 'auto'}}>
                    <table className="row-clickable">
                        <tbody>
                            {allStations.sort((s1, s2) => {
                                if (s1.Navn < s2.Navn) return -1;
                                if (s1.Navn > s2.Navn) return 1;
                                if (s1.Stationsnr < s2.Stationsnr) return -1;
                                if (s1.Stationsnr > s2.Stationsnr) return 1;
                                return 0;
                            }).map(station => {
                                const ix = this.state.selectedStations.indexOf(station.Stationsnr);
                                const selectedIx = selectedStations.findIndex(station2 => station2.Stationsnr === station.Stationsnr);
                                return <tr key={station.Stationsnr} className={selectedIx >= 0 && selectedStations[selectedIx].Levels.indexOf(this.state.viewMode) >= 0 ? 'disabled' : ''} onClick={() => {
                                    if (selectedIx < 0 || selectedStations[selectedIx].Levels.indexOf(this.state.viewMode) < 0) {
                                        if (ix < 0) this.state.selectedStations.push(station.Stationsnr);
                                        else this.state.selectedStations.splice(ix, 1);
                                        this.forceUpdate();
                                    }
                                }}>
                                    <td><input type="checkbox" checked={ix >= 0} disabled={selectedIx >= 0 && selectedStations[selectedIx].Levels.indexOf(this.state.viewMode) >= 0} onChange={() => {
                                        //if (ix < 0) this.state.selectedStations.push(station.Stationsnr);
                                        //else this.state.selectedStations.splice(ix, 1);
                                        //this.forceUpdate();
                                    }}/></td>
                                    <td>{station.Stationsnr}</td>
                                    <td>{station.Navn}</td>
                                    <td>{selectedIx < 0 ? null : selectedStations[selectedIx].Levels.map(lvl => lvl === '0' ? 'A' : (lvl === '1' ? 'G' : (lvl === '2' ? 'S' : 'F'))).join('')}</td>
                                </tr>})}
                        </tbody>
                    </table>
                </div>
                <div style={{position: 'absolute', top: 0, bottom: 0, left: sectionWidth, right: sectionWidth}}>
                    <div style={{width: '100%', textAlign: 'center', position: 'absolute', top: '50%', transform: 'translateY(-50%)'}}>
                        <div>
                            <button className={'btn-primary'} disabled={this.state.selectedStations.length < 1} style={{width: buttonWidth}} onClick={() => {
                                this.props.dispatch(AdminActions.selectStations(this.state.viewMode === '0' ? 'A' : (this.state.viewMode === '1' ? groupId : (this.state.viewMode === '2' ? sectionId : clubId)), this.state.selectedStations, () => {
                                    NotificationManager.success("De markerede stationer er udvalgt til " +  (this.state.viewMode === '0' ? 'alle foreninger' : (this.state.viewMode === '1' ? 'gruppe ' + groupId : (this.state.viewMode === '2' ? 'sektion ' + sectionId : 'forening ' + clubId))) + ".", "Tilvalg", 4000);
                                    this.setState({
                                        selectedStations: [],
                                        selectedSelections: this.state.selectedStations,
                                    });
                                }));
                            }}>Tilføj</button>
                        </div>
                        <div style={{height: '25px'}}/>
                        <div>
                            <button className={'btn-secondary'} disabled={this.state.selectedSelections.length < 1} style={{width: buttonWidth}} onClick={() => {
                                this.props.dispatch(AdminActions.unselectStations(this.state.viewMode === '0' ? 'A' : (this.state.viewMode === '1' ? groupId : (this.state.viewMode === '2' ? sectionId : clubId)), this.state.selectedSelections, () => {
                                    NotificationManager.success("De markerede stationer er fravalgt " +  (this.state.viewMode === '0' ? 'alle foreninger' : (this.state.viewMode === '1' ? 'gruppe ' + groupId : (this.state.viewMode === '2' ? 'sektion ' + sectionId : 'forening ' + clubId))) + ".", "Fravalg", 4000);
                                    this.setState({
                                        selectedStations: this.state.selectedSelections,
                                        selectedSelections: [],
                                    });
                                }));
                            }}>Fjern</button>
                        </div>
                    </div>
                </div>
                <div style={{position: 'absolute', top: 0, bottom: 0, right: 0, width: sectionWidth, overflow: 'auto'}}>
                    <table className="row-clickable">
                        <tbody>
                            {selectedStations.sort((s1, s2) => {
                                if (s1.Navn < s2.Navn) return -1;
                                if (s1.Navn > s2.Navn) return 1;
                                if (s1.Stationsnr < s2.Stationsnr) return -1;
                                if (s1.Stationsnr > s2.Stationsnr) return 1;
                                return 0;
                            }).map(station => {
                                const ix = this.state.selectedSelections.indexOf(station.Stationsnr);
                                return <tr key={station.Stationsnr} className={station.Levels.indexOf(this.state.viewMode) < 0 ? 'disabled' : ''} onClick={() => {
                                    if (station.Levels.indexOf(this.state.viewMode) >= 0) {
                                        if (ix < 0) this.state.selectedSelections.push(station.Stationsnr);
                                        else this.state.selectedSelections.splice(ix, 1);
                                        this.forceUpdate();
                                    }
                                }}>
                                    <td><input type="checkbox" checked={ix >= 0} disabled={station.Levels.indexOf(this.state.viewMode) < 0} onChange={() => {
                                        //if (ix < 0) this.state.selectedSelections.push(station.Stationsnr);
                                        //else this.state.selectedSelections.splice(ix, 1);
                                        //this.forceUpdate();
                                    }}/></td>
                                    <td>{station.Stationsnr}</td>
                                    <td>{station.Navn}</td>
                                    <td>{station.Levels.map(lvl => lvl === '0' ? 'A' : (lvl === '1' ? 'G' : (lvl === '2' ? 'S' : 'F'))).join('')}</td>
                                </tr>})}
                        </tbody>
                    </table>
                </div>
            </div>
            <div style={{position: 'absolute', bottom: 0, left: 0, right: 0, height: footerHeight}}>
                <button className={'btn-primary'} style={{position: 'absolute', bottom: 0, left: 0, width: sectionWidth}} onClick={() => {
                    this.props.dispatch(AdminActions.calculateDistances(this.state.viewMode === '0' ? 'A' : (this.state.viewMode === '1' ? groupId : (this.state.viewMode === '2' ? sectionId : clubId)), () => {
                        NotificationManager.success("Afstande er genberegnet for " + (this.state.viewMode === '0' ? 'alle foreninger' : (this.state.viewMode === '1' ? 'gruppe ' + groupId : (this.state.viewMode === '2' ? 'sektion ' + sectionId : 'forening ' + clubId))) + ".", "Genberegning", 4000);
                    }));
                }}>Beregn afstande for {this.state.viewMode === '0' ? 'alle foreninger' : (this.state.viewMode === '1' ? 'gruppen' : (this.state.viewMode === '2' ? 'sektionen' : 'foreningen'))}</button>
                <button className={'btn-secondary'} style={{position: 'absolute', bottom: 0, right: 0, width: sectionWidth}} onClick={() => {
                    this.props.dispatch(AdminActions.calculateDistances('A', () => {
                        NotificationManager.success("Afstande er genberegnet for alle foreninger.", "Genberegning", 4000);
                    }));
                }}>Beregn afstande for alle foreninger</button>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => ({
    auth: {
        clubNumber: state.auth.clubNumber,
        isClubAdmin: state.auth.isClubAdmin,
        isMainAdmin: state.auth.isMainAdmin,
    },
    admin: {
        clubs: state.admin.clubs,
        stations: state.admin.stations,
        stationSelections: state.admin.stationSelections,
    }
});

export default connect(mapStateToProps, null, null, {withRef: true})(StationSelection);


// WEBPACK FOOTER //
// ./src/client/src/components/reusable/StationSelection.js